// src/admin/pages/Restaurants/CreateMenuForm.js
import React, { useState } from "react";
import "./CreateMenuForm.css";

export default function CreateMenuForm({ restaurant, onMenuCreated }) {
  const [name, setName] = useState("");
  const [active, setActive] = useState(true);
  const [error, setError] = useState("");

  const handleCreateMenu = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const token = localStorage.getItem("access_token");
      const payload = {
        name,
        active,
        restaurant_id: restaurant.id,
        menu_item_ids: [],
      };

      const res = await fetch(`${process.env.REACT_APP_API_URL}/menus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Errore creazione menù");
      }
      const newMenu = await res.json();
      // Aggiungiamo manualmente restaurant_id se non è incluso nella risposta
      newMenu.restaurant_id = restaurant.id;
      onMenuCreated(newMenu);
      setName("");
      setActive(true);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <form className="create-menu-form" onSubmit={handleCreateMenu}>
      {error && <p className="error-text">{error}</p>}
      <div className="form-group">
        <label>Nome Menù</label>
        <input
          type="text"
          placeholder="Nome menù"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>

      <div className="form-group checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={active}
            onChange={(e) => setActive(e.target.checked)}
          />
          <span>Attivo</span>
        </label>
      </div>

      <button type="submit" className="create-menu-btn">Crea Menù</button>
    </form>
  );
}
